import axios from 'axios';

// GAP.AI Analyzer backend (uvicorn app.main:app --port 8000)
export const api = axios.create({
  baseURL: process.env.REACT_APP_ANALYZER_API_URL || 'http://localhost:8000/api/v1',
  headers: {
    'ngrok-skip-browser-warning': 'true',
  },
});

// Attach the shared login's JWT (see AuthContext.jsx, which persists it to
// sessionStorage on login/logout) to every GAP request. This instance is
// separate from the shared `API` instance in @/lib/api because it has its
// own baseURL - it never needed a token before because the backend's GAP
// routes previously had no auth at all (see SalesOS-Backend/gap/core/
// security.py's get_current_user_sso); now that they require the shared
// login, this was the missing piece causing GAP to show no data even while
// logged in.
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
